import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import SCHEDULE_TYPES from '@constants/scheduleTypes';



interface IHandoverDetails {
    time: number;
    school: boolean;
    id: number;
    location?:string;
}


const createNewScheduleCalc = (days: any[], children: number[], startDate: Date, endDate: Date, parentA: number, parentB: number ):ISchedule => {

    let spinDate:Date = getStartDate(startDate);
    const newSchedule:ISchedule = genereateBaseData(parentA,parentA,parentB,children);

    let previousHandover:IHandoverDetails = { time: spinDate.getTime(), school: false, id: 0 };
    let dayCounter:number = 0;
    let currentCustodianIsA:boolean = (days[0].parent === "ParentA");
    let endedWithHandover:boolean = false;

    while (spinDate.getTime() < endDate.getTime()) {
        spinDate = addDays(spinDate, 1);
        dayCounter++;
        const today:any = days[(dayCounter%days.length)];
        const newCustodianIsA:boolean = (today.parent === "ParentA");
        endedWithHandover = false;
        if (newCustodianIsA !== currentCustodianIsA) // we have a handover!!
        {
            previousHandover = addScheduleEntry(currentCustodianIsA, spinDate, 
                today, newSchedule.data, previousHandover);
            currentCustodianIsA = newCustodianIsA;
            endedWithHandover = true;
        }
    }
    if (!endedWithHandover)
    {
        const today:any = days[(dayCounter%days.length)];
        addScheduleEntry(currentCustodianIsA, spinDate, today, newSchedule.data, previousHandover);
    }

    // TODO trim start
    return newSchedule;
};


const gethandoverDetails = (handoverTimes:any, date:Date, previousId:number, isSchoolday:boolean):IHandoverDetails => {
    date.setHours(handoverTimes.hour);
    date.setMinutes(handoverTimes.minutes);

    let location:string|undefined;
    let handOverAtSchool = handoverTimes.atSchool;
    if (handOverAtSchool)
    {
        date.setHours(12);
        date.setMinutes(0);
        if (!isSchoolday)
        {
            handOverAtSchool = false;
        }
    } else {
        location = handoverTimes.location; 
    }

    const newId = previousId+1;
    return { time: date.getTime(), school: handOverAtSchool, id: newId, location };
};

const createScheduleEntry = (entryId:number, thisHandover:any, previousHandover:IHandoverDetails):IScheduleEntry => {
    return {
        id: entryId, startAtSchool: previousHandover.school, startTime: previousHandover.time, 
        endAtSchool: thisHandover.school, endTime: thisHandover.time, startLoc:previousHandover.location,
        endLoc:thisHandover.location, 
    };
};

const addScheduleEntry = (parentA:boolean, date:Date, handoverData:any, 
    schedule:any, previousHandover:IHandoverDetails):IHandoverDetails => {
    let isSchoolday = true;

    const formattedDate = formatDate(date);
 
    if (date.getDay() === 0 || date.getDay() === 6) {
        isSchoolday = false;
    }

    if (parentA) {
        const thisHandover:IHandoverDetails = gethandoverDetails(handoverData, date, previousHandover.id, isSchoolday);
        schedule.scheduleEntriesParentA[thisHandover.id] = createScheduleEntry(thisHandover.id, 
            thisHandover, previousHandover);
        return thisHandover;
    } else {
        const thisHandover:IHandoverDetails = gethandoverDetails(handoverData, date, previousHandover.id, isSchoolday);
        schedule.scheduleEntriesParentB[thisHandover.id] = createScheduleEntry(thisHandover.id, 
            thisHandover, previousHandover);
        return thisHandover;
    }
};

const getStartDate = (startDate:Date) => {
    let date = new Date(startDate);
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    while (date.getDay() !== 1) // rewind until the first monday before this date (unless startDate is an monday)
    {
        date = addDays(date, -1);
    }

    return date;
};

const genereateBaseData = (creator:number, parentANum: number, parentBNum: number, childrenNum:number[]) => {
    return {
        id: 0,
        creatorAccountId: creator,
        status: SCHEDULE_TYPES.WIP,
        data: {
            parentA: parentANum,
            parentB: parentBNum,
            children: childrenNum,
            scheduleEntriesParentA: {},
            scheduleEntriesParentB: {},
        },
        lastHandover:0
    };
};

const addDays = (date: Date, days: number) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};

const formatDate = (date: Date) => {
    const year = date.getFullYear();
    let day = '' + date.getDate();
    let month = '' + (date.getMonth() + 1);
  
    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }
  
    return [year, month, day].join('-');
};

export { createNewScheduleCalc };


// WEBPACK FOOTER //
// ./src/helpers/calendar/CreateNewCalendar.ts